import { render, staticRenderFns } from "./ModalBackofficeEditarProcedimentoPrincipal.vue?vue&type=template&id=fa6c5a28"
import script from "./ModalBackofficeEditarProcedimentoPrincipal.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeEditarProcedimentoPrincipal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports